module.exports = __webpack_public_path__ + "static/media/user.a7968a56.png";